import {environment} from 'src/environments/environment';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {mapParseItem, mapParseList} from '@brunata-angular/util';
import {BuildingDetails, buildingDetailsSchema} from '@shared/models/building-details';
import {Building, buildingSchema} from '@shared/models/building-overview';

@Injectable({
    providedIn: 'root',
})
export class BuildingService {
    private http = inject(HttpClient);

    getBuildings(): Observable<Building[]> {
        return this.http
            .get(`${environment.onlineServiceUrl}/buildings`)
            .pipe(mapParseList(buildingSchema));
    }

    getBuilding(buildingNo: string): Observable<BuildingDetails> {
        const url = `${environment.onlineServiceUrl}/buildings/${buildingNo}`;
        return this.http.get(url).pipe(mapParseItem(buildingDetailsSchema));
    }
}
